import { render } from "./TableCustomizer.vue?vue&type=template&id=b3ce8fbc&scoped=true&lang=true"
import script from "./TableCustomizer.vue?vue&type=script&lang=js"
export * from "./TableCustomizer.vue?vue&type=script&lang=js"

import "./TableCustomizer.vue?vue&type=style&index=0&id=b3ce8fbc&lang=css&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3ce8fbc"]])

export default __exports__